import React, { createContext, useContext, useEffect, useState } from "react";

import { sendData } from "../../lib/dashboard/actions";
import { useSearchParams } from "react-router-dom";

export const SpreadPriceContext = createContext();
const SpreadPriceProvider = ({ children }) => {
  const [percent, setPercent] = useState({
    strike_deviation: 5,
  });
  const [searchParams] = useSearchParams();
  const tableParams = searchParams.get("table");

  const [tableData, setTableData] = useState({ data: [], isLoading: false });
  useEffect(() => {
    const fetchData = async () => {
      const formData = new FormData();
      formData.append("strike_deviation", percent.strike_deviation);
      setTableData((prev) => ({ ...prev, isLoading: true }));
      const res = await sendData(
        percent,
        "/option/price-spread-strategy",
        `?table=${tableParams}`
      );
      if (res?.data)
        setTableData((prev) => ({ ...prev, data: res.data, isLoading: false }));
    };
    fetchData();
  }, [percent]);

  return (
    <SpreadPriceContext.Provider
      value={{
        percent,
        setPercent,
        tableData,
      }}
    >
      {children}
    </SpreadPriceContext.Provider>
  );
};

export default SpreadPriceProvider;

export function useSpreadPriceContext() {
  return useContext(SpreadPriceContext);
}
